import React from 'react';
import UnitCountTwo from '../components/child/UnitCountTwo'
import LastTransactionOne from '../components/child/LastTransactionOne'


const UserDashboardLayer = () => {
  return (
    <section className="row gy-4">
      {/* UnitCountTwo */}
      <UnitCountTwo />

      {/* LastTransactionOne */}
      <LastTransactionOne />

    </section>
  );
};

export default UserDashboardLayer;

